const defaultRender = (value) => (value ? value : "--");

const statusFilter = [
    { text: "Active", value: "active" },
    { text: "Inactive", value: "inactive" },
]
const organizerFilter = [
    { text: "Not Created", value: "not created" },
    { text: "Finished", value: "finished" },
    { text: "Active", value: "active" },
    { text: "Pending", value: "pending" },
]
const taskFilter = [
    { text: "Prepare Tax", value: "Prepare Tax" },
    { text: "E-file", value: "E-file" },
    { text: "Follow Up", value: "Follow Up" },
    { text: "Review Tax", value: "Review Tax" },
    { text: "Verify Doc", value: "Verify Doc" },
]
const signatureFilter = [
    { text: "Pending", value: "pending" },
    { text: "Requested", value: "requested" },
    { text: "Completed", value: "completed" },
]
const paymentFilter = [
    { text: "Paid", value: "Paid" },
    { text: "Unpaid", value: "Unpaid" },
];

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
    },
    {
        title: 'Mobile No',
        dataIndex: 'mobile_no',
        render: defaultRender,
    },
    {
        title: 'Tag',
        dataIndex: 'tag',
        render: defaultRender,
        onFilter: (value, record) => {
            return record?.client_tag?.includes(value)
        },
        width: 200
    },
    {
        title: 'Status',
        dataIndex: 'statusTag',
        render: defaultRender,
        filters: statusFilter,
        onFilter: (value, record) => {
            return record?.status === value;
        },
    },
    {
        title: 'Organizer',
        dataIndex: 'organizer',
        render: defaultRender,
        filters: organizerFilter,
        onFilter: (value, record) => {
            return record?.organizerText?.includes(value);
        },
    },
    {
        title: 'Signature',
        dataIndex: 'signature',
        render: defaultRender,
        filters: signatureFilter,
        onFilter: (value, record) => {
            return record?.signatureText === value;
        },
    },
    {
        title: 'Payment',
        dataIndex: 'payment',
        render: defaultRender,
        filters: paymentFilter,
        onFilter: (value, record) => {
            return record?.paymentText?.includes(value);
        },
    },
    {
        title: 'Task',
        dataIndex: 'task',
        render: defaultRender,
        filters: taskFilter,
        onFilter: (value, record) => {
            return record?.taskText?.includes(value);
        },
    },
    {
        title: 'Assignee',
        dataIndex: 'assign_name',
        render: defaultRender,
        width: 200,
        onFilter: (value, record) => {
            return record?.assign_name?.includes(value)
        },
    },
    {
        title: 'Created Date',
        dataIndex: 'created_at',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        fixed: 'right',
    },
];

export default columns;